import { TableSettings } from '@economic/taco';
import { AccountModel, AccountTypeNumber } from '~/types';

const HEADING_ACCOUNT_TYPES = [AccountTypeNumber.Heading, AccountTypeNumber.HeadingBreak];

export const isHeading = (accountTypeNumber: AccountTypeNumber) => HEADING_ACCOUNT_TYPES.includes(accountTypeNumber);

const compareValues = (a: number | string, b: number | string, desc: boolean) => {
    const valueA = a.toString().toLowerCase();
    const valueB = b.toString().toLowerCase();
    if (valueA > valueB) {
        return desc ? -1 : 1;
    }
    if (valueA < valueB) {
        return desc ? 1 : -1;
    }
    return 0;
};

export const findRowActiveIndex = (
    accounts: AccountModel[],
    selectedAccountNumber?: number,
    sorting?: TableSettings['sorting']
) => {
    const sortedAccounts = sorting
        ? accounts.sort((a, b) => {
              for (const rule of sorting) {
                  const { id, desc } = rule;
                  const comparison =
                      id === 'type.name' ? compareValues(a.type?.name, b.type?.name, desc) : compareValues(a[id], b[id], desc);

                  if (comparison !== 0) {
                      return comparison;
                  }
              }
              return 0;
          })
        : accounts;

    const activeIndex = sortedAccounts.findIndex(({ number }) => number === selectedAccountNumber);
    return activeIndex >= 0 ? activeIndex : undefined;
};
